// extracted by mini-css-extract-plugin
export default {"release-timing-notice":"form_release-timing-notice__ZqMqx","release-timing-notice__primary-value":"form_release-timing-notice__primary-value__+D-0u"};